import piniaPersistConfig from "@/config/piniaPersist";
import {defineStore} from "pinia";
import {EnumTheme} from "@/enum/theme";
import {EnumUserSettingAuthorized, EnumUserSettingOpen} from "@/enum/user";

const id = "SettingStore";

/**
 * 用戶設置
 */
export const SettingStore = defineStore({
    id: id,
    state: () => ({
        theme: EnumTheme.LIGHT,
        region: "zhTW",
        authorized: EnumUserSettingAuthorized.PASSWD,
        entries: {
            edit: EnumUserSettingOpen.SELF
        }
    }),
    getters: {
        isDarkTheme: state => {
            return state.theme === EnumTheme.DARK
        },
        getRegion: state => {
            return state.region
        },
        getAll: state => {
            return state
        }
    },
    actions: {
        setTheme(theme) {
            this.theme  = theme
        },
        setRegion(region) {
            this.region = region;
        },
        setAuthorized(e) {
            this.authorized = e
        },
        setEntriesEdit(e) {
            this.entries.edit = e
        },
    },
    persist: piniaPersistConfig(id)
});
